import styled from "styled-components";
import Split, { SplitProps } from "react-split";
import { FC, ReactNode } from "react";

const StyledSplit = styled(Split)({
  display: "flex",
  flexDirection: "row",
  "& .gutter": {
    backgroundColor: "#eee",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50%",
    "&:hover": {
      backgroundColor: "#ddd",
    },
  },
  "& .gutter.gutter-horizontal": {
    backgroundImage:
      "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==')",
    cursor: "col-resize",
  },
});

interface CustomSplitProps extends SplitProps {
  children: ReactNode;
}

const CustomSplit: FC<CustomSplitProps> = (props) => {
  const { children } = props;

  return <StyledSplit {...props}>{children}</StyledSplit>;
};

export default CustomSplit;
